import { IPrintRecord } from "./index";

export class PrintSlices {
  public breaks: number[] = [];
  public readonly header: number = 0;
  private readonly $el!: HTMLElement;
  private $pr!: IPrintRecord;

  constructor($pr: IPrintRecord | PrintSlices) {
    if ($pr instanceof PrintSlices) {
      return $pr;
    }
    this.$pr = $pr;
    this.$el = $pr.$el;
    if (this.$el) {
      if (
        $pr.selectors?.header &&
        this.domRect(this.querySelector($pr.selectors.header) as HTMLElement)
          .bottom
      ) {
        this.header = this.scale(
          this.domRect(this.querySelector($pr.selectors.header) as HTMLElement)
            .bottom - this.domRect().top
        );
      }
      if ($pr.selectors?.breaks.length) {
        this.querySelectorAll($pr.selectors.breaks.join(", ")).forEach((el) => {
          if (
            this.domRect(el as HTMLElement)[
              $pr.selectors?.breakPosition || "bottom"
            ]
          ) {
            this.breaks.push(
              this.scale(
                (this.domRect(el as HTMLElement)[
                  $pr.selectors?.breakPosition || "bottom"
                ] as number) - this.domRect().top
              )
            );
          }
        });
      }
    }
  }

  domRect(el = this.$el): DOMRect {
    return el?.getBoundingClientRect() || ({} as DOMRect);
  }

  querySelector(selector: string, el = this.$el) {
    return el.querySelector(selector);
  }

  querySelectorAll(selector: string, el = this.$el) {
    return [...el.querySelectorAll(selector)];
  }

  scale(val: number) {
    return val * (this.$pr.scale || 1);
  }
}
